import Vue from 'vue'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
import { ModuleRegistry } from '@ag-grid-community/core'
import '@ag-grid-community/styles/ag-grid.css'
import '@ag-grid-community/styles/ag-theme-quartz.css'
import { AgGridVue } from '@ag-grid-community/vue'

ModuleRegistry.registerModules([ClientSideRowModelModule])
Vue.component('AgGridVue', AgGridVue)
// Vue.use(AgGridVue, {})
